import { Validator } from "@angular/forms/src/directives/validators";
import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS } from "@angular/forms";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[fileValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: FileTypeValidatation,
    multi: true
  }]
})


export class FileTypeValidatation implements Validator {
  @Input("fileValidator") fileTypes: string;
  validate(control: AbstractControl): { [key: string]: any } | null {
    if(!this.fileTypes) return null;
    if (this.fileTypes != undefined && control.value != '' && control.value!=null) {
      var controlType: string[] = control.value[0].name.split('.');
      var type = controlType[controlType.length - 1];
      if (this.fileTypes.toLowerCase().includes(type.toLowerCase())) {
        return null;

      }
      return { 'notValidFileType': true };
    }
    return null;
  }
}
